export function ensureColorHasHashtag(color: string) {
  return "#" + color.replaceAll("#", "");
}
